import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../App";
import Banner from "../../../../Assets/Images/Acx.png";
import BXSImg from "../../../../Assets/Images/GroupXS.png";
import Instruction from "../../../../Assets/Images/Rounds/instruction.png";
import participant from "../../../../Assets/Images/Rounds/participant.png";
import result from "../../../../Assets/Images/Rounds/result.png";
import LearningDescription from "../LearningDescription/LearningDescription";
import LearningDownloadCertificate from "../LearningDownloadCertificate/LearningDownloadCertificate";
import LearningDragAndDrop from "../LearningDragAndDrop/LearningDragAndDrop";
import LearningPayment from "../LearningPayment/LearningPayment";
import LearningResult from "../LearningResult/LearningResult";
import "./ActivitiesLearnNav.css";
import UploadStatusView from "./UploadStatusView";
import ReactPlayer from "react-player";

export default function ActivitiesLearnNav() {
  const [changeRoute, setChangeRoute] = useState(0);
  const { slug } = useParams();
  const [learningSession, setLearningSession] = useState({});
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const countDownDate = new Date(
    moment(learningSession.assignment_reg_end_date).format("LL") +
    " " +
    "23:59:59"
  ).getTime();

  const exp_event_date = new Date(
    moment(learningSession.event_date).format("LL") +
    " " +
    "23:59:59"
  ).getTime();

  useEffect(() => {
    axios.get(`api/user/learning-session/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setLearningSession(res.data.learnigSession);
      }
    });
  }, [slug]);
  console.log('slugslugslug',slug);
  return (
    <>
      <div className="my-3  ">
        <div className="bg-dark mx-3 mb-3 rounded-3">
        {learningSession?.video != null ? (
              <>
                <ReactPlayer
                  url={videoCdnUrl+learningSession?.video}
                  controls={true}
                  playing={false}
                  height={350}
                  width={"100%"}
                  volume={1}
                  className="Live-Video-x"
                  style={{ margin: "0 auto" }}
                />
              </>
            ) : (
              <>
                <img
                  src={
                    learningSession?.banner !== null
                      ? imageCdnUrl+learningSession?.banner
                      : ''
                  }
                  alt={learningSession?.banner}
                />
              </>
            )}

            <center>
            <h5 className="text-light fw-bold pt-3 mx-3">{learningSession && learningSession.title}</h5>
            <p className="p-0 m-0 mx-3 pb-3 text-warning">
            {exp_event_date < new Date().getTime() ? (
                      'Event Date Expired'
                    ) : (
                      moment(learningSession.event_date).format("MMMM Do YYYY, h:mm:ss a") 
                    )} 
            </p>
            </center>
        </div>

        <Tab.Container fluid id="left-tabs-example" defaultActiveKey="first">
          <div className="round1">
            <Nav variant="pills">
              <div className="container-fluid ">
                <div className="d-sm-none d-md-flex justify-content-between flex-wrap">
                  <div className="singleContent d-flex justify-content-center">
                    <div
                      className="card roundCardX"
                      style={{
                        backgroundImage: `url(${BXSImg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="card-body">
                        <div className="text-center my-2 ">
                          <img
                            src={participant}
                            alt=""
                            className="mt-4 textCenterImg"
                          />
                        </div>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="first"
                            className="NavAudition subAudition fw-bold"
                          >
                            Participation
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="singleContent d-flex justify-content-center">
                    <div
                      className="card roundCardX"
                      style={{
                        backgroundImage: `url(${BXSImg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="card-body">
                        <div className="text-center my-2 ">
                          <img
                            src={Instruction}
                            alt=""
                            className="mt-4 textCenterImg"
                          />
                        </div>
                        <div>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="second"
                              className="NavAudition subAudition fw-bold"
                            >
                              Instruction
                            </Nav.Link>
                          </Nav.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="singleContent d-flex justify-content-center">
                    <div
                      className="card roundCardX"
                      style={{
                        backgroundImage: `url(${BXSImg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="card-body">
                        <div className="text-center my-2 ">
                          <img
                            src={result}
                            alt=""
                            className="mt-4 textCenterImg"
                          />
                        </div>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="result"
                            className="NavAuditionX subAudition fw-bold"
                          >
                            Result
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Nav>
          </div>

          <div className="container-fluid my-2">
            <Tab.Content>
              {countDownDate < new Date().getTime() ? (
                <Tab.Pane eventKey="first">
                  <UploadStatusView status="time_out" />
                </Tab.Pane>
              ) : (
                <Tab.Pane eventKey="first">
                  <LearningDragAndDrop learningSessionData={learningSession} />
                </Tab.Pane>
              )}

              <Tab.Pane eventKey="second" className="bg-warning">
                <LearningDescription learningSession={learningSession} />
              </Tab.Pane>

              <Tab.Pane eventKey="result">
                {/* {changeRoute === 0 || 1 ? ( */}
                <LearningResult
                  changeRoute={changeRoute}
                  setChangeRoute={setChangeRoute}
                  learningSession={learningSession}
                />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </>
  );
}
